// extracted by mini-css-extract-plugin
export default {"addCustomerSection":"style_addCustomerSection__rwnE0","actionsSection":"style_actionsSection__Kr-gF","formSection":"style_formSection__fHnbH"};